<template>
  <div>
    <section>
      <div class="container">
        <div class="row justify-content-center">

          <div class="col-lg-7 text-center mb-5">
            <h2>LIFESTYLE ARTICLES</h2>
            <p>
              Immerse yourself in the art of indulgence, where luxury living takes centre stage.<br>
              Discover secluded holiday destinations, exquisite wines, the finest restaurants, private events, flawless interior decorating,
              inspiring landscaping designs and more. Embrace the extraordinary and delve into a lavish lifestyle.
            </p>
          </div>


          <!-- DUBAI -->
          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">

                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/luxnewdubai" style="text-decoration: none;" class="d-block">
                      <img
                        src="/images/lifestyle/luxnewdubai.jpg"
                        style="border-bottom-right-radius: 30px;"
                        class="mw-100"
                        alt="Dubai office opens as Chas Everitt builds global property bridges"
                      />
                    </a>
                  </div>
                </div>

                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">

                  <a href="/article/luxnewdubai" style="text-decoration: none;" class="d-block">
                    <h2 class="text-start text-uppercase">
                      <strong>
                        Dubai office opens as Chas Everitt builds global property bridges
                      </strong>
                    </h2>
                  </a>

                  <p class="blog-text">
                    Chas Everitt International has created a new gateway between South Africa and one of the world’s most dynamic property and financial markets with the opening of its first office in Dubai.
                    <br><br>
                    The move is a significant step for the group, which has for more than 40 years built a reputation around exceptional service, long-term client relationships and local market expertise fused with the global connections that come with its membership of Leading Real Estate Companies of the World® (LeadingRE).
                  </p>

                </div>

              </div>
            </div>

            <a
              class="social-links switch-bg-dblue mb-0 cta-link"
              href="/article/luxnewdubai"
              id="lifestyle-cta"
            >
              READ MORE
            </a>
          </div>


          <!-- CURRENCIES DIRECT -->
          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">

                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/luxcurrencies" style="text-decoration: none;" class="d-block">
                      <img
                        src="/images/lifestyle/luxcurrencies.jpg"
                        style="border-bottom-right-radius: 30px;"
                        class="mw-100"
                        alt="Unlocking seamless cross-border property acquisitions"
                      />
                    </a>
                  </div>
                </div>

                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">

                  <a href="/article/luxcurrencies" style="text-decoration: none;" class="d-block">
                    <h2 class="text-start text-uppercase">
                      <strong>
                        Unlocking seamless cross-border property acquisitions
                      </strong>
                    </h2>
                  </a>

                  <p class="blog-text">
                    For affluent investors, purchasing prime real estate is rarely just about finding the perfect property. In the international market especially, navigating currency volatility, exchange control restrictions, and varying tax architectures is where the true success of an acquisition is decided.
                    <br><br>
                    Whether you are a South African investor acquiring a villa in Portugal, or an overseas buyer purchasing a prime property in Johannesburg or Cape Town, it is crucial to manage how your capital moves across borders.
                  </p>

                </div>

              </div>
            </div>

            <a
              class="social-links switch-bg-dblue mb-0 cta-link"
              href="/article/luxcurrencies"
              id="lifestyle-cta"
            >
              READ MORE
            </a>
          </div>


          <!-- WHITE WINE -->
          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">

                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/luxwhitewine" style="text-decoration: none;" class="d-block">
                      <img
                        src="/images/lifestyle/luxwhitewine.jpg"
                        style="border-bottom-right-radius: 30px;"
                        class="mw-100"
                        alt="Cooler, crisper and increasingly world-class"
                      />
                    </a>
                  </div>
                </div>

                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">

                  <a href="/article/luxwhitewine" style="text-decoration: none;" class="d-block">
                    <h2 class="text-start text-uppercase">
                      <strong>
                        Cooler, crisper and increasingly world-class
                      </strong>
                    </h2>
                  </a>

                  <p class="blog-text">
                    Summer is unfolding across the country, bringing with it the promise of languorous evenings enjoying one of life’s simplest pleasures: a perfectly chilled white wine.
                    <br><br>
                    Fortunately for South Africans, we happen to live in a country producing some increasingly exciting examples of the genre, which international wine lovers and critics are beginning to notice in a big way.
                  </p>

                </div>

              </div>
            </div>

            <a
              class="social-links switch-bg-dblue mb-0 cta-link"
              href="/article/luxwhitewine"
              id="lifestyle-cta"
            >
              READ MORE
            </a>
          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      property: {

      }
    };
  },
};
</script>